import { createContext, PropsWithChildren } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';

import { GrowthProfileModal_AssetClassFragment } from './graphql/GrowthProfileModal.generated';
import { TaxDrag_DefaultsFragment } from './taxDrag/TaxDrag.generated';

export interface GrowthProfileModalContextShape {
  growthProfileId: string | null;
  isDefault: boolean;
  isDuplicating: boolean;
  assetClasses: GrowthProfileModal_AssetClassFragment[];
  householdId: string;
  taxDragDefaults?: TaxDrag_DefaultsFragment;
}

export const GrowthProfileModalContext =
  createContext<GrowthProfileModalContextShape>({
    growthProfileId: null,
    isDefault: false,
    isDuplicating: false,
    assetClasses: [],
    householdId: '',
  });

export function GrowthProfileModalContextProvider({
  growthProfileId,
  isDefault,
  isDuplicating,
  children,
  assetClasses,
  householdId,
  taxDragDefaults,
}: PropsWithChildren<GrowthProfileModalContextShape>) {
  return (
    <GrowthProfileModalContext.Provider
      value={{
        growthProfileId,
        isDefault,
        isDuplicating,
        assetClasses,
        householdId,
        taxDragDefaults,
      }}
    >
      {children}
    </GrowthProfileModalContext.Provider>
  );
}

export function useGrowthProfileModalContext() {
  return useGuardedContext(
    GrowthProfileModalContext,
    'GrowthProfileModalContextProvider'
  );
}
